import { TId } from '@apia/util';

export function parseTOKS(str: string, ...rep: TId[]) {
  rep.forEach((c, ind) => {
    str = str.replaceAll(`<TOK${ind + 1}>`, String(c));
  });
  return str;
}

export const identifiers = Object.freeze({
  ids: {
    attributes: () => 'attributes',
    businessClasses: () => 'businessClasses',
    entities: () => 'entities',
    dashboards: () => 'dashboards',
    documents: () => 'documents',
    entityInstance: () => 'entityInstance',
    events: () => 'events',
    externalInterfaces: () => 'externalInterfaces',
    fields: () => 'fields',
    foreignKeys: () => 'foreignKeys',
    forms: () => 'forms',
    image: () => 'image',
    images: () => 'images',
    outcomes: () => 'outcomes',
    panels: () => 'panels',
    performers: () => 'performers',
    pools: () => 'pools',
    processes: () => 'processes',
    processTasks: () => 'processTasks',
    profiles: () => 'profiles',
    queries: () => 'queries',
    relatedProcesses: () => 'relatedProcesses',
    roles: () => 'roles',
    rules: () => 'rules',
    states: () => 'states',
    supervisor: () => 'supervisor',
    tasks: () => 'tasks',
    trigger: () => 'triggers',
    useCase: () => 'useCase',
    users: () => 'users',
    widget: () => 'widget',
    widgets: () => 'widgets',
  },
  eventTypes: {
    entity: [
      ['onaftercreate', 'onAfterCreate'],
      ['oncreate', 'onCreate'],
      ['ondetail', 'onDetail'],
      ['onupdate', 'onUpdate'],
    ],
    field: [
      ['oncolselect', 'onColSelect'],
      ['onclick', 'onClick'],
      ['onchange', 'onChange'],
      ['onmodalreturn', 'onModalReturn'],
      ['onrowdelete', 'onRowDelete'],
      ['onrowadd', 'onRowAdd'],
      ['onrowsort', 'onRowSort'],
      ['populate', 'onPopulate'],
    ],
    form: [
      ['onafterprint', 'onAfterPrint'],
      ['onbeforeprint', 'onBeforePrint'],
      ['onload', 'onLoad'],
      ['onreload', 'onReload'],
      ['onsubmit', 'onSubmit'],
    ],
    process: [
      ['oncancel', 'onCancel'],
      ['oncomplete', 'onComplete'],
      ['oncreate', 'onCreate'],
      ['ondetail', 'onDetail'],
      ['onfinalize', 'onFinalize'],
      ['onoverdue', 'onOverdue'],
      ['onresume', 'onResume'],
      ['onrollback', 'onRollback'],
      ['onsuspend', 'onSuspend'],
      ['onwarning', 'onWarning'],
    ],
    task: [
      ['onacquire', 'onAcquire'],
      ['oncomplete', 'onComplete'],
      ['ondelegate', 'onDelegate'],
      ['ondetail', 'onDetail'],
      ['onelevate', 'onElevate'],
      ['onoverdue', 'onOverdue'],
      ['onreasign', 'onReasign'],
      ['onready', 'onReady'],
      ['onrelease', 'onRelease'],
      ['onrollback', 'onRollback'],
      ['onstepchg', 'onStepChange'],
      ['onsave', 'onSave'],
      ['onwarning', 'onWarning'],
      ['onwork', 'onWork'],
    ],
  },
  /**
   * Los plurals se usan principalmente a la hora de nombrar colecciones que
   * tienen más de un elemento
   */
  plurals: {
    attribute: () => 'attributes',
    businessClass: () => 'businessClasses',
    dashboard: () => 'dashboards',
    dashboardPanel: () => 'panels',
    document: () => 'documents',
    entity: () => 'entities',
    entityInstance: () => 'instances',
    entityInstanceAttribute: () => 'entityInstanceAttributes',
    event: () => 'events',
    externalInterface: () => 'externalInterfaces',
    field: () => 'fields',
    formField: () => 'fields',
    foreignKey: () => 'foreignKeys',
    form: () => 'forms',
    grid: () => 'grids',
    image: () => 'images',
    panel: () => 'panels',
    performer: () => 'performers',
    pool: () => 'pools',
    process: () => 'processes',
    processTask: () => 'tasks',
    profile: () => 'profiles',
    outcome: () => 'outcomes',
    query: () => 'queries',
    relatedProcess: () => 'relatedProcesses',
    role: () => 'roles',
    rule: () => 'rules',
    state: () => 'states',
    supervisor: () => 'supervisors',
    task: () => 'tasks',
    trigger: () => 'triggers',
    useCase: () => 'useCases',
    user: () => 'users',
    widget: () => 'widgets',
  },
  /**
   * Los tipos se usan principalmente al armar relaciones uno a uno.
   */
  types: {
    attribute: () => 'attribute',
    businessClass: () => 'businessClass',
    dashboard: () => 'dashboard',
    dashboardPanel: () => 'panel',
    document: () => 'document',
    entity: () => 'entity',
    entityInstance: () => 'entityInstance',
    entityInstanceAttribute: () => 'entityInstanceAttribute',
    event: () => 'event',
    externalInterface: () => 'externalInterface',
    field: () => 'field',
    formField: () => 'field',
    foreignKey: () => 'foreignKey',
    form: () => 'form',
    image: () => 'image',
    outcome: () => 'outcome',
    query: () => 'query',
    panel: () => 'panel',
    performer: () => 'performer',
    pool: () => 'pool',
    process: () => 'process',
    processTask: () => 'task',
    profile: () => 'profile',
    relatedProcess: () => 'relatedProcess',
    role: () => 'role',
    rule: () => 'rule',
    state: () => 'state',
    supervisor: () => 'supervisor',
    task: () => 'task',
    trigger: () => 'trigger',
    useCase: () => 'useCase',
    user: () => 'user',
    widget: () => 'widget',
  },
});
